module.exports = __webpack_public_path__ + "static/media/29.a5db44b2.JPG";